// Teklif satırları → Aşama Geçmişi olayları (müşteri geri bildirimi 2026-08:
// "teklifi kabul eden adayın aşama geçmişinde teklif süreci görünmüyor").
// Yalnız ZAMAN DAMGALI gerçekler olaya çevrilir: gönderim (sentAt), kabul
// (acceptedAt), ret (rejectedAt + gerekçe). withdrawn/expired'ın kendi damgası
// tutulmadığından sahte tarih üretilmez — akıbet, gönderim olayının `status`
// metasında görünür (FE `ats.offer.status.*` ile çevirir). Maaş/prim alanları
// BİLEREK taşınmaz: geçmiş sekmesini gören herkes tutarı görmemeli.
export function offerTimelineItems(offers) {
  if (!Array.isArray(offers)) return [];
  const items = [];
  offers.forEach((o) => {
    if (!o?.sentAt) return; // gönderilmemiş (draft/onay aşaması) teklif yolculuğa girmez
    items.push({
      kind: 'offer',
      ts: o.sentAt,
      data: { id: o.id, version: o.version, event: 'sent', status: o.status },
    });
    if (o.acceptedAt) {
      items.push({
        kind: 'offer',
        ts: o.acceptedAt,
        data: { id: o.id, version: o.version, event: 'accepted', status: o.status },
      });
    }
    if (o.rejectedAt) {
      items.push({
        kind: 'offer',
        ts: o.rejectedAt,
        data: { id: o.id, version: o.version, event: 'rejected', status: o.status, reason: o.rejectedReason || null },
      });
    }
  });
  return items;
}
